import React from 'react';
import { useTranslation } from 'react-i18next';
import { SideNavLink } from '@carbon/react';
import { ChevronLeft } from '@carbon/react/icons';
import { useAppStore } from 'src/states/app';

/** Locale, theme and the user's own links live in the header's UserMenu; collapse stayed
 *  here because it is a property of the rail, not of the person using it. */
function MainSideNavSettings() {
  const setFullscreen = useAppStore((state) => state.setFullscreen);
  const { t } = useTranslation();

  return (
    <SideNavLink
      large
      renderIcon={() => <ChevronLeft size={32} />}
      onClick={() => setFullscreen(true)}
      id={'collapse-sidenav-button'}
    >
      {t('sideNav.collapse')}
    </SideNavLink>
  );
}

export default React.memo(MainSideNavSettings);
